module.exports = __webpack_public_path__ + "img/payment-account-payment-done.924c85fe.svg";